// @flow

import React from 'react'

type PropTypes = {
  isLock?: ?boolean,
  children: any,
}

export default class ScrollControlView extends React.Component<PropTypes, *> {
  constructor(props: PropTypes) {
    super(props)
    this.handleScroll = this.handleScroll.bind(this)
  }

  componentDidMount() {
    if (this.contentsElement) {
      this.contentsElement.addEventListener('touchmove', this.handleScroll, {
        passive: false,
      })
      this.contentsElement.addEventListener('wheel', this.handleScroll, {
        passive: false,
      })
    }
  }

  componentWillUnmount() {
    if (this.contentsElement) {
      this.contentsElement.removeEventListener('touchmove', this.handleScroll)
      this.contentsElement.removeEventListener('wheel', this.handleScroll)
    }
  }

  handleScroll: Function
  contentsElement: ?HTMLDivElement

  handleScroll(e: Event) {
    if (this.props.isLock) {
      e.preventDefault()
    }
  }

  render() {
    return (
      <div
        ref={el => {
          this.contentsElement = el
        }}
      >
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/atoms/ScrollControlView/index.jsx